import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Row, Checkbox, Button, message, Spin } from 'antd';
import { getExpenseTypes } from "../../actions/expense-config.actions";
import { expenseTypesSelector } from "../../selector/expense-config.selector";
import { isValid, isValidArray } from "../../utils/utilities";
import { postCall } from "../../utils/network.util";
import { GET_EXPENSE_CONFIG_BY_OPERATOR_CODE_URL, SAVE_EXPENSE_CONFIG_URL } from "../../utils/api-url";
import '../../styles/operator-config-page.style.scss';
import './expense-config.page.style.scss';

export const ExpenseConfigPage = () => {
    const dispatch = useDispatch();
    const expenseTypes = useSelector(expenseTypesSelector);
    
    const [form] = Form.useForm();
    const operatorCode = global.operatorCode;
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    // const [expenseConfigData, setExpenseConfigData] = useState(null);

    useEffect(() => {
        dispatch(getExpenseTypes());
    }, [dispatch]);

    useEffect(() => {
        if (operatorCode && expenseTypes) {
            loadExpenseConfig(operatorCode);
        }
    }, [operatorCode, expenseTypes]);

    const loadExpenseConfig = (operatorCode) => {
        setLoading(true);
        // Note : we need get from admin server for these
        postCall(GET_EXPENSE_CONFIG_BY_OPERATOR_CODE_URL, { operatorCode })
            .then((response) => {
                setLoading(false);
                if (response.status === "SUCCESS" && response.payload.Status === "SUCCESS") {
                    const configData = response.payload.Payload;
                    // setExpenseConfigData(configData);
                    
                    // Set form values based on the config data
                    if (configData) {
                        const formValues = {};
                        // Map expense config fields to form values
                        // Fields: bata, toll, pooja, bus_expenses, parking, driver, attender, grease_and_air, misc
                        Object.keys(expenseTypes).forEach(key => {
                            formValues[key] = configData[key] === 1;
                        });
                        form.setFieldsValue(formValues);
                    } else {
                        // If no config found, all checkboxes should be unchecked
                        const formValues = {};
                        Object.keys(expenseTypes).forEach(key => {
                            formValues[key] = false;
                        });
                        form.setFieldsValue(formValues);
                    }
                } else {
                    message.error("Failed to load expense config");
                    // setExpenseConfigData(null);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error("Error loading expense config:", error);
                message.error("Error loading expense config");
            });
    };

    const handleSubmit = (values) => {
        if (!operatorCode) {
            message.warning("Operator code not found");
            return;
        }

        setSaving(true);
        
        // Convert checkbox values (true/false) to database format (1/0)
        const expenseConfig = {};
        Object.keys(expenseTypes).forEach(key => {
            expenseConfig[key] = values[key] ? 1 : 0;
        });

        postCall(SAVE_EXPENSE_CONFIG_URL, {
            operatorCode: operatorCode,
            expenseConfig: expenseConfig
        })
            .then((response) => {
                setSaving(false);
                if (response.status === "SUCCESS" && response.payload.Status === "SUCCESS") {
                    message.success("Expense config saved successfully");
                    // Reload the config to reflect changes
                    loadExpenseConfig(operatorCode);
                } else {
                    message.error("Failed to save expense config");
                }
            })
            .catch((error) => {
                setSaving(false);
                console.error("Error saving expense config:", error);
                message.error("Error saving expense config");
            });
    };

    const renderExpenseTypeCheckboxes = () => {
        if (!isValid(expenseTypes) || !isValidArray(Object.keys(expenseTypes))) {
            return null;
        }

        // Sort expense types by order
        const sortedExpenseTypes = Object.keys(expenseTypes).sort((a, b) => {
            const orderA = expenseTypes[a]?.order || 0;
            const orderB = expenseTypes[b]?.order || 0;
            return orderA - orderB;
        });

        return sortedExpenseTypes.map((key) => {
            const expenseType = expenseTypes[key];
            return (
                <Col span={8} key={key}>
                    <Form.Item
                        name={key}
                        valuePropName="checked"
                        className="expense-config-item"
                    >
                        <Checkbox className="expense-config-checkbox">
                            <span className="expense-config-label">{expenseType.label}</span>
                        </Checkbox>
                    </Form.Item>
                </Col>
            );
        });
    };

    return (
        <div className="expense-config-page-root">
            <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                <Col span={24}>
                    <h2 className="expense-config-title">Expense Config</h2>
                </Col>
            </Row>

            <Spin spinning={loading}>
                <Form
                    form={form}
                    onFinish={handleSubmit}
                    layout="vertical"
                    className="expense-config-form"
                >
                    <Row gutter={[24, 20]} className="expense-config-row">
                        {renderExpenseTypeCheckboxes()}
                    </Row>

                    <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
                        <Col>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={saving}
                                size="large"
                                className="expense-config-save-btn"
                            >
                                Save Config
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </div>
    );
};
